// @flow
import React from 'react'
import styled from 'styled-components'

const Component = styled.header`
  padding: 3rem 0;
  background: #fff;
`

const TextContainer = styled.div`
  position: relative;
  text-align: center;
  margin-bottom: 2rem;

  &::after {
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    height: 1px;
    border-bottom: 1px solid rgb(220, 225, 230);
    content: '';
  }
`

const Text = styled.h1`
  display: inline-block;
  text-transform: uppercase;
  position: relative;
  background: #fff;
  padding: 0 2rem;
  z-index: 1;
`

type Props = {
  text: string,
  children?: any
}

const PageHeader = ({ text, children }: Props) => (
  <Component>
    <div className="container">
      <TextContainer>
        <Text>{text}</Text>
      </TextContainer>
      <div style={{ fontSize: '1.25rem', fontWeight: '300' }}>{children}</div>
    </div>
  </Component>
)

export default PageHeader



// WEBPACK FOOTER //
// ./src/components/PageHeader/index.js